import Cookies from "js-cookie";
import { ref } from "vue";

export function useCookies() {
    /**
     * Sets a cookie with a specified name, value, and expiration in days.
     * @param name - The name of the cookie
     * @param value - The value of the cookie
     * @param days - Optional expiration in days (defaults to 7)
     */
    const setCookie = (name: string, value: string, days: number = 7): void => {
        Cookies.set(name, value, { expires: days });
    };

    /**
     * Gets the value of a cookie by name.
     * @param name - The name of the cookie
     * @returns The value of the cookie or `undefined` if not found
     */
    const getCookie = (name: string): string | undefined => {
        return Cookies.get(name);
    };

    /**
     * Removes a cookie by name.
     * @param name - The name of the cookie
     */
    const removeCookie = (name: string): void => {
        Cookies.remove(name);
    };

    /**
     * Reactive function to track the value of a cookie by name.
     * @param name - The name of the cookie
     * @returns A reactive reference of the cookie value
     */
    const useCookie = (name: string) => {
        const cookieValue = ref<string | undefined>(getCookie(name));

        // Watch for changes to the cookie and update the ref
        setInterval(() => {
            cookieValue.value = getCookie(name);
        }, 1000); // Adjust interval as needed

        return cookieValue;
    };

    return { setCookie, getCookie, removeCookie, useCookie };
}
